import { useState } from "react";
import { MeetingTabs } from "./MeetingTabs";
import { Meeting } from "@/types/meeting";
// import { mockMeetings } from "./data/meetingMocks";
import { MeetingForm } from "./MeetingForm";
import { useMeetings } from "./hooks/MeetingsHooks";
import { Calendar, Plus, FileText, ArrowLeft } from 'lucide-react';
import { TemplatesView } from "./components/TemplatesView";


export const MeetingsComponent = () => {
    const [editingMeeting, setEditingMeeting] = useState<Meeting | null>(null);
    const [showTemplates, setShowTemplates] = useState(false);
    const [showNewMeeting, setShowNewMeeting] = useState<boolean>(false);
    const { meetings, updateMeeting, addMeeting } = useMeetings();


    
    const handleCloseModal = () => {
        setShowNewMeeting(false);
        setEditingMeeting(null);
    };

    const handleMeetingUpdate = (updatedMeeting: Partial<Meeting>) => {
        if (editingMeeting) {
          // Update existing meeting
          updateMeeting({ ...updatedMeeting, id: editingMeeting.id });
        } else {
          // Add new meeting
          const newMeeting: Meeting = {
            ...updatedMeeting,
            agenda: [],
            tasks: [],
            notes: '',
          } as Meeting;
          addMeeting(newMeeting);
        }
        handleCloseModal();
      };

    return (
        <>

<div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {showTemplates && (
                <button
                  onClick={() => setShowTemplates(false)}
                  className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900"
                >
                  <ArrowLeft className="w-5 h-5 mr-1" />
                  Back to Meetings
                </button>
              )}
              <Calendar className="w-8 h-8 text-blue-600 mr-3" />
              <h1 className="text-3xl font-bold text-gray-900">Meeting Manager</h1>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setShowTemplates(true)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-700 hover:bg-green-800"
              >
                <FileText className="w-5 h-5 mr-1" /> View Meeting Templates
              </button>
              <button
                onClick={() => setShowNewMeeting(true)}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
              >
                <Plus className="w-5 h-5 mr-1" /> New Meeting
              </button>
            </div>
          </div>

          {showTemplates ? (
          <TemplatesView />
        ) : (
            <MeetingTabs
            meetings={meetings}
            onEditMeeting={(meeting) => {
                setEditingMeeting(meeting);
              }}
            />
        ) }
        {(showNewMeeting || editingMeeting) && (
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-xl max-w-5xl w-full mx-4 my-6 mt-16">
                <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">
                    {editingMeeting ? 'Edit Meeting' : 'Schedule New Meeting'}
                </h2>
                </div>
                <div className="px-6 py-4 max-h-[calc(100vh-12rem)] overflow-y-auto">
                <MeetingForm
                    initialData={editingMeeting || undefined}
                    onSubmit={handleMeetingUpdate}
                    onCancel={handleCloseModal}
                />
                </div>
            </div>
            </div>
        )}
        </>
    );
}